export default {
  get name(): string {
    return 'ExpoContacts';
  },
};
